<template>
    <div>
        <template v-if="!isInitialized">
            <div class="block-container">
                <van-empty description="正在读取中..."/>
            </div>
        </template>
        <template v-if="isInitialized && fail">
            <div class="block-container">
                <van-empty :description="failMsg"/>
            </div>
        </template>
        <template v-if="!fail && isInitialized">
            <div style="display: flex; align-items: center; justify-content: center;">
                <div class="info-container">
					<van-cell title="基本信息" class="sub-title sub-cell"></van-cell>
                    <van-cell title="抬头名">
						<template #title>
							<span class="sub-title">{{invoiceTypes[info.invoice_type]}}/{{type[info.type]}}</span>
							<span style="font-size: 16px;">{{info.name}}</span>
						</template>
					</van-cell>
                    <van-cell title="状态">
                        <span class="cell-value">{{invoiceStatusList[info.status]}}</span>
                    </van-cell>
					<van-cell title="电子发票号" :value="info.electron_invoice_no" v-if="info.invoice_type === 'electron'" class="long-value"></van-cell>
                    <van-cell title="失败原因" :value="info.failed_reason" v-if="info.failed_reason"></van-cell>

					<van-cell title="订单信息" class="sub-title sub-cell"></van-cell>
					<van-cell title="金额" v-if="info.total_amount">
						{{info.total_amount}}
					</van-cell>

					<van-cell title="订单号" class="long-value" v-if="info.invoice_user_order_no && info.invoice_user_order_no.length > 0">
						<span v-for="(item, index) in info.invoice_user_order_no" :key="index">{{item}}</span>
					</van-cell>
					<van-cell title="开票站点" v-if="info.site_name">
						{{info.site_name}}
					</van-cell>
					<van-cell title="开票油品" v-if="info.oil_type_name">
						{{info.oil_type_name}}
					</van-cell>

					<van-cell title="物流信息" v-if="info.invoice_type === 'paper'" class="sub-title sub-cell"></van-cell>
					<van-cell title="收件人" v-if="info.invoice_type === 'paper'" :value="info.receive_name"></van-cell>
					<van-cell title="收件人号码" v-if="info.invoice_type === 'paper'" :value="info.receive_phone"></van-cell>
					<van-cell title="收件地区" v-if="info.invoice_type === 'paper'" class="long-value" :value="`${info.receive_province} ${info.receive_city} ${info.receive_district}`"></van-cell>
					<van-cell title="收件地址" v-if="info.invoice_type === 'paper'" :value="info.receive_address"></van-cell>
                    <van-cell title="物流公司" v-if="info.invoice_type === 'paper' && (info.status == '2' || info.status == '3')" :value="info.express_company"></van-cell>
					<van-cell title="物流单号" v-if="info.invoice_type === 'paper' && (info.status == '2' || info.status == '3')" :value="info.express_no"></van-cell>

					<van-cell title="单位信息" v-if="info.type === 'company'" class="sub-title sub-cell"></van-cell>
					<van-cell title="纳税人识别号" v-if="info.type === 'company'" class="long-value" :value="info.taxpayer_no"></van-cell>
					<van-cell title="企业地址" v-if="info.type === 'company'" class="long-value" :value="info.business_address"></van-cell>
					<van-cell title="电话" v-if="info.type === 'company'" :value="info.business_telephone"></van-cell>
					<van-cell title="开户行" v-if="info.type === 'company'" :value="info.bank_of_deposit"></van-cell>
					<van-cell title="银行账号" v-if="info.type === 'company'" :value="info.bank_account"></van-cell>

					<van-cell title="开票时间" :value="info.created_at"></van-cell>
					<van-cell title="备注" :value="info.remarks"></van-cell>

                    <div style="width: 100%; padding: 10px 0;">
                        <van-button v-if="info.invoice_type === 'paper' && info.status == '2'" type="danger" round class="van-button van-button--block" @click="confirmReceipt(info.id)">确认收货</van-button>
                        <van-button v-if="canReissue" type="warning" round class="van-button van-button--block" @click="toReissue" style="margin-top: 10px;">换开</van-button>
                        <template v-if="info.invoice_type === 'electron' && (info.status === '3' || info.status === '6')">
                            <van-button type="info" round class="van-button van-button--block" @click="downLoadPdf(info.invoice_url)" style="margin-top: 10px;">下载电子发票</van-button>
                            <van-button type="default" round class="van-button van-button--block" @click="isShowSendPhoneInvoiceDialog = true" style="margin-top: 10px;">发送到手机</van-button>
                            <van-button type="default" round class="van-button van-button--block" @click="isShowSendEmailInvoiceDialog = true" style="margin-top: 10px;">发送到邮箱</van-button>
                        </template>
                    </div>
                </div>
            </div>
        </template>

        <van-dialog v-model="isShowSendEmailInvoiceDialog" title="请填写邮箱" show-cancel-button :before-close="sendEmailInvoiceCallback">
            <van-field v-model="sendEmailInvoice" placeholder="请输入邮箱" clearable />
        </van-dialog>
        <van-dialog v-model="isShowSendPhoneInvoiceDialog" title="请填写手机号" show-cancel-button :before-close="sendPhoneInvoiceCallback">
            <van-field v-model="sendPhoneInvoice" placeholder="请输入手机号" clearable />
        </van-dialog>
    </div>
</template>

<script>
    import api from '../../assets/js/api'

    export default {
        name: 'InvoiceDerail',
        data () {
            return {
                isInitialized: false,
                fail: false,
                failMsg: '',
                info: {},
                id: this.$route.query.id,
				invoiceTypes: {
					electron: '电子发票',
					paper: '纸质发票'
				},
				type: {
					personal: '个人抬头',
					company: '单位抬头'
				},
				isLoading: false,
                isShowSendEmailInvoiceDialog: false,
                sendEmailInvoice: '',
                isShowSendPhoneInvoiceDialog: false,
                sendPhoneInvoice: '',
            }
        },
        created() {
            api.request('/invoice/detail', {
                id: this.$route.query.id
            }).then(res => {
                this.info = res.data;
            }).catch(res => {
                this.fail = true;
                this.failMsg = res.msg
            }).finally(() => {
                this.isInitialized = true;
            })
        },
        methods: {
			confirmReceipt(id) {
				const that = this;
				if(this.isLoading) return;
				this.isLoading = true;
				this.$toast.loading({
                    message: '请求处理中',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/invoice/confirm_receipt', {
                    id: id
                }).then(res => {
					that.$dialog({massage: res.msg})
                }).finally(() => {
                    that.isLoading = false;
                    that.$toast.clear();
                })
			},
            toReissue() {
                this.$router.push({
                    name: 'InvoiceReissue',
                    query: {
                        id: this.info.id,
                    },
                })
            },
            downLoadPdf (url) {
                let u = navigator.userAgent
                let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

                // if (isIOS) {
                //     this.$dialog({message: 'IOS系统暂不支持下载'})
                // } else {
                //     const pdfUrl = url;
                //     window.location.href = pdfUrl
                // }
                window.location.href = url;
            },
            sendPhoneInvoiceCallback(action, done){
                if(action === 'confirm'){
                    // return done(false);
                    if(this.sendPhoneInvoice === ''){
                        this.$toast({
                            type: 'text',
                            message: '请输入手机号',
                        });
                        return done(false);
                    }

                    api.request('/invoice/send_invoice', {
                        id: this.id,
                        phone: this.sendPhoneInvoice,
                    }).then(res => {
                        this.$toast({
                            type: 'text',
                            message: res.msg,
                        });
                        done(true);
                    }).catch(res => {
                        this.$toast({
                            type: 'text',
                            message: res.msg,
                        });
                        done(false);
                    });
                }else{
                    done(true);
                }
            },
            sendEmailInvoiceCallback(action, done){
                if(action === 'confirm'){
                    if(this.sendEmailInvoice === ''){
                        this.$toast({
                            type: 'text',
                            message: '请输入邮箱',
                        });
                        return done(false);
                    }

                    api.request('/invoice/send_invoice', {
                        id: this.id,
                        email: this.sendEmailInvoice,
                    }).then(res => {
                        this.$toast({
                            type: 'text',
                            message: res.msg,
                        });
                        done(true);
                    }).catch(res => {
                        this.$toast({
                            type: 'text',
                            message: res.msg,
                        });
                        done(false);
                    });
                }else{
                    done(true);
                }
            },
        },
        computed: {
			invoiceStatusList() {
				return this.$store.state.systemEnum.company.user_invoice && this.$store.state.systemEnum.company.user_invoice.status || {};
			},
            canReissue() {
                if (!this.info || !this.info.id) {
                    return false;
                }
                let status = String(this.info.status || '');
                if (this.info.invoice_type === 'electron') {
                    return status === '3';
                }
                return false;
            },
		},
    }
</script>

<style lang="scss" scoped>
    .info-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px;
        width: 95%;
        flex-direction: column;

		.order-id{
			font-size: 0.3rem;
		}

		.sub-title {
			font-size: 14px;
			color: #999;
			display: block;
		}

		.sub-cell {
			color: #333;
			padding:5px 16px;
			font-weight: bold;
			line-height: 30px;
		}

		.receipt {
			margin-left: 15px;
		}

        .long-value {
            .van-cell__value {
                flex: 2;
            }
        }

        /deep/ .van-cell:nth-child(1) {
            border-top-left-radius: 0.5rem;
            border-top-right-radius: 0.5rem;
			padding-top: 0.5rem;
        }

        /deep/ .van-cell:last-child {
            border-bottom-left-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
			padding-bottom: 0.5rem;
        }

        .cell-value {
            position: relative;
            overflow: hidden;
            color: #969799;
            text-align: right;
            vertical-align: middle;
        }

        .button-in-cell {
            height: 0.7rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/invoice/InvoiceDetail.vue